import { Reducer } from 'redux';

import { FormActionTypes, FormListState } from './types';

export const defaultState: FormListState = {
    loadingForms: false,
    page: 1,
    limit: 10,
    formList: [],
    count: 0,
    formsCount: 0,
    globalFormsCount: 0,
    DeletingForm: false,
    name: null,
    form: null,
    ispublic: false,
    haveClassicForms: false,
};

const reducer: Reducer = (state: FormListState = defaultState, action): FormListState => {
    switch (action.type) {
        case FormActionTypes.LOADING_START:
            return {
                ...state,
                page: action.payload.page,
                limit: action.payload.limit,
                loadingForms: action.payload.loadingForms,
            };
        case FormActionTypes.LOADING_SUCCESS:
            return {
                ...state,
                formList: action.payload.formList,
                formsCount: action.payload.formsCount,
                globalFormsCount: action.payload.globalFormsCount,
                loadingForms: action.payload.loadingForms,
            };
        case FormActionTypes.LOADING_ERROR:
            return { ...state, loadingForms: action.payload.loadingForms };
        case FormActionTypes.DELETE_ARRAY_SUCCESS:
        case FormActionTypes.DELETE_ARRAY_START:
        case FormActionTypes.DELETE_START:
        case FormActionTypes.DELETE_ERROR:
        case FormActionTypes.DELETE_ARRAY_ERROR:
        case FormActionTypes.DELETE_SUCCESS:
        case FormActionTypes.CHECK_IF_HAVE_CLASSIC_FORMS_SUCCESS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export { reducer as formList };

export default reducer;
